import AboutStyle from "../aboutCard/aboutCard.module.css"

export default function AboutCard({ heading, text, logo, right }) {
    return (
        <div className={AboutStyle.container}>
            <h4 style={{ fontWeight: "600", color: "#8D3C25"}}>{heading}</h4>
            <h6 style={{ lineHeight: "150%", fontWeight: "400", width: "100%", height: "100px" }}>{text}</h6>
            <div className={AboutStyle.imageContainer}>
                <span className={AboutStyle.logo}
                    style={{ float: right ? "right" : "none" }}>
                    {logo}
                </span>
            </div>

        </div>
    )
}